import { render, staticRenderFns } from "./downloadPack.vue?vue&type=template&id=0a636fca&"
import script from "./downloadPack.vue?vue&type=script&lang=js&"
export * from "./downloadPack.vue?vue&type=script&lang=js&"
import style0 from "./downloadPack.vue?vue&type=style&index=0&id=0a636fca&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports